<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				<img src="~img/logo.svg"  style="width:50px;float:left;padding-right:12px;display:inline;padding-top:15px;"><img src="~img/index_system_name.png"  style="width:120px;float:left;padding-left:6px;display:inline;padding-top:18px;">
			</el-col>
			<el-col :span="10">
				<div class="tools" @click.prevent="collapse">
					<i class="fa fa-align-justify"></i>
				</div>
			</el-col>
			<el-col :span="4" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner"><img src='~img/avatar-128-128.png' /> {{sysUserName}}</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item  @click.native="changePsw">修改密码</el-dropdown-item>
						<el-dropdown-item :disabled="userRoleIdentity == 'level-untrue'" @click.native="contactAdmin">联系管理员</el-dropdown-item>
						<el-dropdown-item @click.native="getHelpDocument">帮助文档</el-dropdown-item>
						<el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'">
				<!--导航菜单 :default-openeds="openeds"-->
				<el-menu :default-active="$route.path"  class="el-menu-vertical"  id="lastclass" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed">
					<template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
						<el-submenu :index="index+''" v-if="!item.leaf">
							<template slot="title"><i :class="item.iconCls"></i>{{item.name}}
							
							</template>
							<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}
							</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}
						    <tipnotes :redval="redMsgCount">
									<template  scope='redtemp'>
										<i class="redtip bg-danger" v-show="redtemp.text<100 && redtemp.text>0">
											{{redtemp.text}}
										</i>
										<i class="redtip bg-danger" v-show="redtemp.text >=100 ">
										99+
										</i>
									</template>
                            </tipnotes>
						</el-menu-item>
					</template>
				</el-menu>
				<!--导航菜单-折叠后-->
				
				<ul class="el-menu el-menu-vertical collapsed"  ref="menuCollapsed">
					<li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
						<template v-if="!item.leaf">
							<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
							<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"> 
								<li v-for="child in item.children" v-if="!child.hidden" :key="child.path" class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}</li>
							</ul>
						</template>
						<template v-else>
							<li class="el-submenu">
								<div class="el-submenu__title el-menu-item" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
							</li>
						</template>
					</li>
				</ul>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
		    <el-dialog title="修改密码" v-model="changePswDialogVisible" @close="cancelChangePswFormAddSubmit">
                <el-form :model="changePswForm" :rules="changePswFormRules" ref="changePswForm">
                    <el-form-item label="旧密码" prop="oldPass" label-width="100px">
                        <el-input type="password" v-model="changePswForm.oldPass" auto-complete="off"></el-input>
                    </el-form-item>
					<el-form-item label="新密码" prop="newPass" label-width="100px">
                        <el-input type="password" v-model="changePswForm.newPass" auto-complete="off"></el-input>
                    </el-form-item>
					<el-form-item label="确认新密码" prop="newPassConfirm" label-width="100px">
                        <el-input type="password" v-model="changePswForm.newPassConfirm" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="cancelChangePswFormAddSubmit">取 消</el-button>
                <el-button type="primary" @click="changePswFormOnSubmit">确 定</el-button>
              </div>
            </el-dialog>
			<el-dialog title="联系管理员" v-model="contactDialogVisible" @close="cancelContactFormAddSubmit">
                <el-form :model="contactForm"  :rules="contactFormRules" ref="contactForm">
                    <el-form-item label="问题标题" prop="title" label-width="100px">
                        <el-input v-model="contactForm.title" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="问题描述" prop="content" label-width="100px"> 
                        <el-input v-model="contactForm.content" style="font-size:14px;" auto-complete="off" type="textarea" :rows="3"></el-input>
                    </el-form-item>
                </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="cancelContactFormAddSubmit">取 消</el-button>
                <el-button v-bind:disabled="addSubmitButtonDisabled" type="primary" @click="contactFormOnSubmit">确 定</el-button>
              </div>
            </el-dialog>
			<el-dialog title="帮助文档" v-model="getHelpDocDialogVisible" @close="cancelGetHelpDocFormSubmit">
				
                <el-form :model="getHelpDocForm" :rules="getHelpDocFormRules" ref="getHelpDocForm">
					<el-col :span="24" style="padding-top:15px;">
						<div>
							<img src="~img/help_pdf.png"  style="width:140px;display:inline;padding:60px;padding-bottom:30px;">
							<img src="~img/help_chm.png"  style="width:150px;display:inline;padding:60px;padding-bottom:30px;">
						</div>
					</el-col>	
                    <el-radio-group v-model="getHelpDocForm.type" >
						<el-radio style="margin-left:120px;" class="radio" label="1">pdf</el-radio>
						<el-radio style="margin-left:260px;" class="radio" label="2">chm</el-radio>
					</el-radio-group>
                </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="getHelpDocFormOnSubmit">确认下载</el-button>
              </div>
            </el-dialog>
			<el-dialog title="密码到期提醒" v-model="pswOverRemindDialogVisible" @close="cancelPswOverRemindFormSubmit">
                <span >{{upComingExpirePw}}</span>
              <div slot="footer" class="dialog-footer">
                <el-button @click="nextPswOverRemindFormSubmit">下次再说</el-button>
                <el-button  type="primary" @click="gotoChangePsw">立即修改密码</el-button>
              </div>
            </el-dialog>
			<el-dialog title="项目到期提醒" v-model="projectOverRemindDialogVisible" @close="cancelProjectOverRemindFormSubmit">
                <span >{{upComingExpireProject}}</span>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancelProjectOverRemindFormSubmit">好的</el-button>
              </div>
            </el-dialog>
	</el-row>
</template>

<script>
    import api from '@/api';
	import tools from '@/util/tools';
	import Vue from 'vue'
	import global from '@/config/global_config'
	import tipnotes from '@/components/tipnotes'

	export default {
		components: { tipnotes },
		data() {
			return {
				redMsgCount:"0",
				sysName:'Command Centre',
				collapsed:false,
				openeds: ['1','2','3','4','5','6'],
				sysUserName: '',
				sysUserAvatar: '',
				changePswDialogVisible:false,
				contactDialogVisible:false,
				contactFormRules: {
					title: [
						{ required: true, message: '请输入问题标题', trigger: 'blur' },
						{ min: 1, max: 50, message: '输入长度在1到50个字符之间'}
					],
					content: [
						{ required: true, message: '请输入问题内容', trigger: 'blur' },
						{ min: 1, max: 200, message: '输入长度在1到200个字符之间'}
					]
			    },
			    contactForm: {title:'',content:''},
				changePswFormRules: {
					oldPass: [
						{ required: true, message: '请输入旧密码', trigger: 'blur' },
						{ pattern: /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$/ ,message: '请输入8-20位且同时包含大小写字母数字的密码', trigger: 'blur'}
					],
					newPass: [
						{ required: true, message: '请输入新密码', trigger: 'blur' },
						{ pattern: /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$/ ,message: '请输入8-20位且同时包含大小写字母数字的密码', trigger: 'blur'}
					],
					newPassConfirm: [
						{ required: true, message: '确认新密码', trigger: 'blur' },
						{ pattern: /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$/ ,message: '请输入8-20位且同时包含大小写字母数字的密码', trigger: 'blur'}
					]
			    },
				changePswForm: {newPass:'',oldPass:'',newPassConfirm:''},
				selectTable: {},
				addSubmitButtonDisabled:false,
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				getHelpDocDialogVisible:false,
				getHelpDocForm:{
					type:''
				},
				getHelpDocFormRules:{

				},
				upComingExpirePw:tools.strIsEmpty(sessionStorage.getItem('upComingExpirePw'))?'':sessionStorage.getItem('upComingExpirePw'),
				pswOverRemindDialogVisible:false,
				upComingExpireProject:tools.strIsEmpty(sessionStorage.getItem('upComingExpireProject'))?'':sessionStorage.getItem('upComingExpireProject'),
				projectOverRemindDialogVisible:false,
			}
		},
		methods: {
			onSubmit() {
				console.log('submit!');
			},
			handleopen() {
			},
			handleclose() {
			},
			handleselect: function (a, b) {
			},
			logout: function () {
				this.$confirm('确认退出吗?', '提示', {showClose:false}).then(() => {
					api.account_logout_request().then(
						res => {
							sessionStorage.removeItem('user');
							sessionStorage.removeItem('localRoutes');
							this.$router.push('/login');
							location.reload();
						}
					)	
				}).catch(function (e) {
					console.log(e);
					sessionStorage.removeItem('user');
					sessionStorage.removeItem('localRoutes');
					this.$router.push('/login');
					location.reload();
                });
			},
			changePsw:function () {
				this.changePswDialogVisible = true;
			},
			changePswFormOnSubmit: function () {
				if(this.changePswForm.newPass != this.changePswForm.newPassConfirm){
                    tools.error(this,'新密码两次输入不一致');
                    return;
                }
				let param = {newPass:this.changePswForm.newPass,oldPass:this.changePswForm.oldPass,accountId:global.getAccountId()};
				console.log(param);
				this.listLoading = true;
				api.account_updatePwd_request(param).then((res) => {
					this.listLoading = false;
					this.changePswDialogVisible = false;
					this.$refs.changePswForm.resetFields();
					tools.success(this,"密码修改成功,请重新登陆");
					sessionStorage.removeItem('user');
					sessionStorage.removeItem('localRoutes');
					this.$router.push('/login');
					location.reload();
				}).catch(function (e) {
					console.log(e);
					tools.error(new Vue(),e.message);
                });
				this.listLoading = false;
			},
			contactAdmin:function () {
				this.contactDialogVisible = true;
			},
			contactFormOnSubmit: function () {
				this.$refs.contactForm.validate((valid) => {
					if (valid) {
						this.addSubmitButtonDisabled=true;
						let param = this.contactForm;
						console.log(param);
						this.listLoading = true;
						let self = this;
						api.account_contactAdministrator_request(param).then((res) => {
							this.contactDialogVisible = false;
							tools.success(this,"提交成功");
							this.$refs.contactForm.resetFields();
							this.addSubmitButtonDisabled=false;
						}).catch(function (e) {
							console.log(e);
							self.addSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
                        });
						this.listLoading = false;
					}
					else{
						console.log(this.contactForm);
					}
				})
			},
			collapse:function(){
				this.collapsed=!this.collapsed;
				var uiwidth = document.getElementById('lastclass');
				if(uiwidth.offsetWidth===0){
					uiwidth.style.width = "230px"
				}
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			},
			cancelChangePswFormAddSubmit(){
				this.changePswDialogVisible = false
				this.$refs.changePswForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			cancelContactFormAddSubmit(){
				this.contactDialogVisible = false
				this.$refs.contactForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			getCountAlarmUnRead:function () {
				let param = { };
				api.currentAlarm_countAlarmUnRead_request(param).then((res) => {
					this.redMsgCount = res.data.unReadCount;
				}).catch(function (e) {
					if(e.message)tools.error(new Vue(),e.message);
				});
			},
			getHelpDocument(){
				this.getHelpDocDialogVisible = true;
			},
			cancelGetHelpDocFormSubmit(){
				this.getHelpDocDialogVisible = false
				this.$refs.getHelpDocForm.resetFields();
			},
			getHelpDocFormOnSubmit(){
				sessionStorage.getItem('upComingExpirePw');
			},
			gotoChangePsw:function () {
				sessionStorage.removeItem('upComingExpirePw');
				this.pswOverRemindDialogVisible = false;
				this.changePswDialogVisible = true;
			},
			nextPswOverRemindFormSubmit:function () {
				sessionStorage.removeItem('upComingExpirePw');
				this.pswOverRemindDialogVisible = false;
			},
			cancelPswOverRemindFormSubmit:function () {
				this.pswOverRemindDialogVisible = false;
			},
			cancelProjectOverRemindFormSubmit:function () {
				sessionStorage.removeItem('upComingExpireProject');
				this.projectOverRemindDialogVisible = false;
			},
		},
		mounted() {
			var user = this.$store.state.user;
			if (user) {
				this.sysUserName = user.account || '';
				this.sysUserAvatar = '~img/avatar-128-128.png';
			}
			this.getCountAlarmUnRead();
			if(!tools.strIsEmpty(sessionStorage.getItem('upComingExpirePw'))){
				this.pswOverRemindDialogVisible = true;
			}
			if(!tools.strIsEmpty(sessionStorage.getItem('upComingExpireProject'))){
				this.projectOverRemindDialogVisible = true;
			}
		},
		// 每20秒刷新一次
        created () {
            this.timer = setInterval(() =>{
                this.getCountAlarmUnRead()
            },1000* 10)
		},
		
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: $color-primary;
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 30px;
						height: 30px;
						border-radius: 20px;
						margin: 16px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				height:60px;
				font-size: 16px;
				padding-left:14px;
				padding-right:12px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:230px;
			}
			.logo-collapse-width{
				width:70px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 230px;
				width: 230px;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:70px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 230px;
				width: 230px;
			}
			.content-container {
				flex:1;
				overflow-y: scroll;
				padding: 20px;
				.breadcrumb-container {
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Home.vue?4f4ab4cf